module.exports = __webpack_public_path__ + "img/vid-3.fe0aeccb.png";